import CountUp from 'countup.js/dist/countUp.min'

export default {
  init() {
    // JavaScript to be fired on the team page
  },
  finalize() {
      var counter = 0;
      reconfig_boxes();

    function msieversion() {

      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");

      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./))  // If Internet Explorer, return version number
      {
        return true;
      }
      return false;
    }

    $(document).on("click", ".member", function() {
      if(!msieversion()) {
        if ($(window).width() > 768) {
          clearBox();

          $(this).addClass("open");
          var box = $(this).siblings(".m-box");
          // box.find(".member-caption").removeClass("closed");
          box.addClass('active');
        }
      }else{
        window.location.href =  $(this).closest(".col-6").find(".link-arrow").attr("href");
      }
    });

    $(document).on("click", ".close-box, .close-box", function() {
        clearBox();
    });

    function reconfig_boxes() {
      $(document).find(".m-box").each(function (i, el) {
        // >XL
        if($(window).width() >= 1200) {
          if(counter >= 6) {
            counter = 0;
          }
          if(counter >= 3) {
            $(el).addClass("left");
            $(el).siblings('.member').addClass('left');
          }
        }
        // >LG <XL
        if($(window).width() >= 1024 && $(window).width() < 1200) {
          if(counter >= 4) {
            counter = 0;
          }
          if(counter >= 2) {
            $(el).addClass("left");
            $(el).siblings('.member').addClass('left');
          }
        }
        // >MD <LG
        if($(window).width() >= 768 && $(window).width() < 1024) {
          if(counter >= 3) {
            counter = 0;
          }
          if(counter >= 2) {
            $(el).addClass("left");
            $(el).siblings('.member').addClass('left');
          }
        }
        // >0 <MD
        if($(window).width() < 768) {
          if(counter >= 2) {
            counter = 0;
          }
          if(counter >= 1) {
            $(el).addClass("left");
            $(el).siblings('.member').addClass('left');
          }
        }

        counter++;
      });
    }

    function clearBox() {
        $(".m-box").removeClass('active');
        // $(".m-box .member-caption").addClass('closed');
        $(".member").removeClass("open");
    }

      var canStart = true;
      function loadCounters() {
          if($('.counters').visible() && canStart) {
              new CountUp("count1", 0, $("#count1").data("val"), 0, 3).start();
              new CountUp("count2", 0, $("#count2").data("val"), 0, 3).start();
              new CountUp("count3", 0, $("#count3").data("val"), 0, 3).start();
              new CountUp("count4", 0, $("#count4").data("val"), 0, 3).start();
              canStart = false;
          }
      }
      setTimeout(function() {
          loadCounters();
      }, 700);
      $(window).scroll(function() {
          loadCounters();
      });

      // Action for load more authors
      const moreSelector = '.team-wrapper a[href="#more"]';
      let canScrollLoad = true;
      $(moreSelector).on('click', function(e) {
        e.preventDefault();
        let start_offset = parseInt($(this).attr('data-offset'));
        let page_id = $(this).attr('data-page-id');
        let step_offset = parseInt($(this).attr('data-step-offset'));
        let sender = this;
        if ($('body.page-id-' + page_id).length) {
          $(document).find('#loading-tmp-message').remove();
          $(sender).hide();
          $(sender).parent().prepend('<div id="loading-tmp-message">Loading...</div>');
          $.ajax({
            method: 'POST',
            url: '/wp/wp-admin/admin-ajax.php',
            data: { action: 'show_more_authors_team_page', start_offset: start_offset, step_offset: step_offset, page_id: page_id },
          }).done(function(response) {
            if (response.more_available) {
              //$(sender).show();
              canScrollLoad = true;
            } else {
              $(sender).hide();
              canScrollLoad = false;
            }

            $(document).find('#loading-tmp-message').remove();
            $(sender).attr('data-offset', start_offset+step_offset);
            $('.team-wrapper .ajax-content').append(response.html);
            reconfig_boxes();
          });
        } else {
          console.log('Invalid Page ID for loading more authors');
        }
      });
      if ($(moreSelector).data('is-apple-device')) {
        if (screen.width >= 1200) {
          $(moreSelector).attr('data-step-offset', 6*2);
        } else if (screen.width >= 992) {
          $(moreSelector).attr('data-step-offset', 4*2);
        } else {
          $(moreSelector).attr('data-step-offset', 3*2);
        }
        setTimeout(function() { $('.team-wrapper a[href="#more"]').click(); }, 700);

        $(document).on("scroll", function() {
          if ($('.ajax-more').visible() && canScrollLoad) {
            $('.team-wrapper a[href="#more"]').click();
            canScrollLoad = false;
          }
        });
      }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/team.js